export default __webpack_public_path__ + "static/media/landing-image-third.0386ff8a.png";